<template>
  <div>
    <v-sheet class="py-6 py-md-8 px-3" color="primary">
      <TitleWidget :small="xsOnly" dark>
        {{ title }}
      </TitleWidget>
    </v-sheet>

    <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16">
      <LoadingWidget v-if="loading" />

      <FullCalendar v-else :options="calendarOptions" />
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

const _config = {
  mod: "school-calendar",
};

const _data = {
  title: "Calendário Escolar",
  loading: true,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ title, start, end }) => {
        const startDate = new Date(start);
        const endDate = new Date(end);

        return {
          title,
          start: startDate.setTime(startDate.getTime() + 12 * 3600000),
          end: endDate.setTime(endDate.getTime() + 12 * 3600000),
        };
      });
    },
    calendarOptions() {
      const item = {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        timeZone: "UTC",
        events: this.items,
        locale: "pt-BR",
        displayEventTime: false,
        eventDisplay: "block",
        eventBackgroundColor: "#0D4EA0",
        eventTextColor: "#ffffff",
        titleFormat: {
          year: "numeric",
          month: "long",
        },
        headerToolbar: {
          start: "",
          center: "title",
          end: "prev,next",
        },
      };

      if (this.xsOnly) item.height = "auto";

      return item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    TitleWidget,
    LoadingWidget,
    FullCalendar,
  },
};
</script>

<style>
.fc-icon {
  height: auto !important;
}
</style>
